import { CommunicationTypeEnum, } from '@zurich/api/party';
export const partyCommunicationChannelUtils = {
    isPartyGeoAddress,
    isPartyPostBoxAddress,
    isPartyEmailAddress,
    isPartyPhoneNumber,
    getPartyGeoAddress,
    getPartyPostBoxAddress,
    getPartyEmailAddress,
    getPartyPhoneNumber,
};
function isPartyGeoAddress(channel) {
    return channel.communicationChannelType === CommunicationTypeEnum.GEO;
}
function isPartyPostBoxAddress(channel) {
    return channel.communicationChannelType === CommunicationTypeEnum.POSTBOX;
}
function isPartyEmailAddress(channel) {
    return channel.communicationChannelType === CommunicationTypeEnum.EMAIL;
}
function isPartyPhoneNumber(channel) {
    return channel.communicationChannelType === CommunicationTypeEnum.TELEPHONE;
}
function getPartyGeoAddress(channel) {
    if (!isPartyGeoAddress(channel))
        throw new Error('CommunicationChannelType is not GEO');
    return channel;
}
function getPartyPostBoxAddress(channel) {
    if (!isPartyPostBoxAddress(channel))
        throw new Error('CommunicationChannelType is not POSTBOX');
    return channel;
}
function getPartyEmailAddress(channel) {
    if (!isPartyEmailAddress(channel))
        throw new Error('CommunicationChannelType is not EMAIL');
    return channel;
}
function getPartyPhoneNumber(channel) {
    if (!isPartyPhoneNumber(channel))
        throw new Error('CommunicationChannelType is not TELEFON');
    return channel;
}
